const changeHour = (hour) => {
  var H = +hour.substr(0, 2);
  var h = H % 12 || 12;
  var ampm = H < 12 || H === 24 ? 'am' : 'pm';
  return `${h}${hour.substring(3, 5) === '30' ? hour.substr(2, 3) : ''}${ampm}`;
};
export default changeHour;
